import React, { useEffect } from 'react'
import { MenuItem } from '@mui/material'
import { FormattedMessage } from 'react-intl'
import Select, { SelectChangeEvent } from '@mui/material/Select'
import { useCookies } from 'react-cookie'

export default function Countries({
  setCountrySelected,
  countrySelected,
  countries
}: {
  countrySelected: string
  setCountrySelected: Function
  countries: Array<{ COUNTRYCODE: string; DISPLAY: string; ID: number }>
}) {
  const [cookies] = useCookies(['country_code'])

  useEffect(() => {
    if (cookies.country_code) {
      const result = countries.filter((item) => item.COUNTRYCODE === cookies.country_code)[0]
      if (result) {
        setCountrySelected(result.COUNTRYCODE)
      }
    }
  }, [cookies.country_code, countries, setCountrySelected])

  const handleChange = (event: SelectChangeEvent) => {
    setCountrySelected(event.target.value)
  }

  return (
    <Select
      sx={{ textAlign: 'left', mb: 2 }}
      size='small'
      value={countrySelected}
      fullWidth
      onChange={handleChange}
      data-cy='country-dropdown'
    >
      <MenuItem value={'none'} disabled>
        <FormattedMessage id='sales.selectCountry' />
      </MenuItem>
      {countries.map((item) => (
        <MenuItem value={item.COUNTRYCODE} key={item.COUNTRYCODE} data-cy='country-dropdownItem'>
          {item.DISPLAY}
        </MenuItem>
      ))}
    </Select>
  )
}
